import React from 'react';

/**
 * SectionHeading — a section's heading on the page background (visual
 * refresh, 2026-10-01). Sections are separated by space and this heading, not
 * wrapped in a card.
 *
 * Props:
 * @param {React.ReactNode} title - Set in the heading serif (20px, the 19px
 *   floor for the serif is respected)
 * @param {React.ReactNode} detail - Optional muted fact on the right ("Oct 5 – 11",
 *   "3 places"); tabular numerals so dates and counts don't jiggle
 * @param {React.ReactNode} action - Optional right-side control ("See all"),
 *   shown instead of `detail` when both are passed
 * @param {'h2'|'h3'|'h4'} as - Heading level; pick by the page outline, the
 *   look stays the same
 * @param {string} id - For aria-labelledby on the section it heads
 * @param {string} className - Extra classes on the wrapper
 */
function SectionHeading({ title, detail = null, action = null, as: Heading = 'h2', id, className = '' }) {
  return (
    <div className={`flex items-baseline justify-between gap-3 mb-3 ${className}`}>
      <Heading id={id} className="font-display font-medium text-xl leading-snug text-content-primary min-w-0">
        {title}
      </Heading>
      {action
        ? <div className="flex-shrink-0">{action}</div>
        : detail && <span className="flex-shrink-0 text-sm text-content-secondary tabular-nums">{detail}</span>}
    </div>
  );
}

export default SectionHeading;
